<template>
  <div class="hero-software hero-swiper-btn" id="home">
    <div class="container_f1">
      <div class="swiper-wrapper">
        <swiper :options="swiperOption">
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h2 hero-content-title" style="font-size: 50px">Cloud-Based Social Media
                  Automation Software</h2>
                <h6 class="hero-content-subtitle" style="font-size: 18px">No coding skills required
                  to create Automation<br>Connect.
                  Engage. Plan. 10X Faster.</h6>

                <span @click="gotologin">
                  <base-button type="warning">
                  Get Started
                  </base-button>
                </span>
              </div>
              <div class="hero-thumb pr-100">
                <img src="../../assets/img/hero/hero-software/software-thumb-1.png"
                     class="img-fluid"
                     alt="hero thumb">
              </div>
            </div>
          </div>
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h2 hero-content-title" style="font-size: 50px">Let us take care of your
                  Social Media
                  Automation</h2>
                <h6 class="hero-content-subtitle" style="font-size: 18px">YourSynchronicity doesn't
                  require users to be
                  experts.</h6>
                <span @click="gotologin">
                  <base-button type="warning">
                  Get Started
                  </base-button>
                </span>
              </div>
              <div class="hero-thumb">
                <img src="../../assets/img/hero/hero-software/software-thumb-2.png"
                     class="img-fluid"
                     alt="hero thumb">
              </div>
            </div>
          </div>
          <div class="swiper-slide" :style="bgImg">
            <div class="hero-item">
              <div class="hero-content">
                <h2 class="h2 hero-content-title" style="font-size: 50px">Your business deserves
                  better support</h2>
                <h6 class="hero-content-subtitle" style="font-size: 18px">Focus only on what matters
                  for you and your
                  business</h6>
                <span @click="gotologin">
                  <base-button type="warning">
                  Get Started
                  </base-button>
                </span>
              </div>
              <div class="hero-thumb pr-100">
                <img src="../../assets/img/hero/hero-software/software-thumb-3.png"
                     class="img-fluid"
                     alt="hero thumb">
              </div>
            </div>
          </div>
          <!-- Optional controls -->
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                bgImg: {
                    backgroundImage: `url(${require("../../assets/img/hero/hero-software/software-shape.png")})`
                },
                swiperOption: {
                    speed: 1500,
                    loop: true,
                    effect: 'fade',
                    autoplay: false,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                }
            };
        },
        methods: {
            gotologin() {
                this.$router.push({name: 'login'});
            },
        }
    };
</script>

<style lang="scss" scoped>

  @import '../../assets/scss/variabls.scss';
  @import '../../assets/scss/elements/hero-software.scss';
</style>

